import React from "react";
import MightyInput from "mighty-input";

import "./style.css";

const tokens = {
  username: /^@[A-Za-z0-9_.]+/,
  hashtag: /^#[A-Za-z0-9_]+/,
  word: /^\S+/,
  ws: /^\s+/m,
};

export function MessageInput({ className = "messageInput", value, ...props }) {
  const toks = Object.entries(tokens);

  const render = next => {
    const out = [];
    let remain = next;

    while (remain.length) {
      let match;
      for (const [token, re] of toks) {
        match = remain.match(re);

        if (match) {
          out.push(
            <span key={out.length + 1} className={`${className}-${token}`}>
              {match[0]}
            </span>,
          );
          break;
        }
      }

      if (!match) {
        break;
      }

      remain = remain.slice(match[0].length);
    }

    if (remain.length) {
      out.push(remain);
    }

    return out;
  };

  return (
    <MightyInput
      value={value}
      render={render}
      className={className}
      {...props}
    />
  );
}
